module.exports = __webpack_public_path__ + "img/slide2.9a54e27c.jpg";